export enum CaseType {
  Return = 'Return',
  Warranty = 'Warranty',
  NotDefined = '-',
}
